var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-foto","title":"Galleria","size":"lg","hide-footer":""},on:{"shown":_vm.clickFoto}},[_c('h3',{staticStyle:{"color":"red"}},[_vm._v("Seleziona una foto da visualizzare")]),_c('vue-picture-swipe',{attrs:{"items":_vm.foto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }